import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  RequestOptions,
  Response
} from "@angular/http";
import "rxjs/add/operator/map";
import { environment } from "../../../environments/environment";

@Injectable()
export class AuthenticationService {
  public baseUrl = environment.baseUrl;
  //public baseUrl = "http://localhost:35634";
  private IsAuthenticated: boolean;
  private Access_Token: string;
  constructor(private http: Http) { }
  setUserLoggedIn() {
    this.IsAuthenticated = true;
  }
  getUserLoggedIn() {
    return this.IsAuthenticated;
  }
  setAccessToken(token: string) {
    this.Access_Token = token;
  }
  getAccessToken() {
    return localStorage.getItem("Access_Token_" + environment.AppName);
  }
  public jwt() {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return new RequestOptions({ headers: headers });
  }
  login(username: string, password: string) {
    var body =
      "grant_type=" +
      "password&" +
      "username=" +
      username +
      "&password=" +
      password;
    return this.http
      .post(this.baseUrl + "/Token", body, this.jwt())
      .map((response: Response) => {
        return response.json();
      });
  }
  logout() {
    localStorage.removeItem("IsAuthenticated_" + environment.AppName);
    localStorage.removeItem("Access_Token_" + environment.AppName);
    localStorage.removeItem("UserId" + environment.AppName);
    localStorage.removeItem("LocationId_" + environment.AppName)
    localStorage.removeItem("BranchId_" + environment.AppName)
  }
  public getHeader() {
    let headers = new Headers({
      Authorization: "Bearer " + this.getAccessToken()
    });
    headers.append("Content-Type", "application/json");
    return new RequestOptions({ headers: headers });
  }
  public getnoauthHeader() {
    let headers = new Headers({
      Authorization: "No Auth"
    });
    headers.append("Content-Type", "application/json");
    return new RequestOptions({ headers: headers });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/authentication.service.ts